module.exports = __webpack_public_path__ + "static/img/vip-info1.7b986b28.png";